import React, { useEffect } from 'react';
import { styled } from '../../../stitches.config';

import Box from '../Box';

export default props => {
    /* const startTime = Date.parse('2022-02-24T23:59:00');
 
     const [days, setDays] = React.useState(0);
     const calculateTime = (deadline) => {
         const time = Date.now() - deadline;
         if (time < 0) {
             setDays(0)
         } else {
             setDays(Math.floor(time / (1000 * 60 * 60 * 24)))
         }
     }
 
     useEffect(() => {
         const interval = setInterval(() => {
             calculateTime(startTime);
         }, 1000);
         return () => clearInterval(interval);
     }, []);
 
     const leadingNumber = (value) => value < 10 ? "0" + value : value; 
     <span>{String(leadingNumber(days))}</span>
      */


    return (
        <div className="container">
            <Section>
                <Box {...props} id="b1" type="ASpecialDaysCounterTimer" settings={props.settings.b1} classes="" />
                <Wrapper>
                    <div className="col-xs-12 col-md-6 border--mobile">
                        <Box {...props} id="b2" type="ASpecialDaysCounter" settings={props.settings.b2} classes="" />
                    </div>
                    <div className="col-xs-12 col-md-6 border--mobile">
                        <Box {...props} id="b3" type="ASpecialDaysCounter" settings={props.settings.b3} classes="" />
                    </div>
                    <div className="border"></div>
                    <div className="col-xs-12 col-md-6 border--mobile">
                        <Box {...props} id="b4" type="ASpecialDaysCounter" settings={props.settings.b4} classes="" />
                    </div>
                    <div className="col-xs-12 col-md-6 border--last">
                        <Box {...props} id="b5" type="ASpecialDaysCounter" settings={props.settings.b5} classes="" />
                    </div>
                </Wrapper>
            </Section>
        </div>
    );
}

const Section = styled("section", {
    borderTop: "2px solid #131212",
    padding: "0px",
    marginTop: "0px",
    "@media (min-width: 992px)": {
        display: "flex",
        borderBottom: "2px solid #131212"
    }
});

const Wrapper = styled("div", {
    width: "100%",
    fontSize: "14px",
    "@media (min-width: 992px)": {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center"
    },
    ".col-xs-12": {
        padding: "0px"
    },
    ".border": {
        "@media (min-width: 992px)": {
            width: "100%",
            borderBottom: "1px solid #E8E8E8"
        }
    },
    ".border--mobile": {
        borderBottom: "1px solid #E8E8E8",
        "@media (min-width: 992px)": {
            borderWidth: "0px"
        }
    },
    ".border--last": {
        borderBottom: "2px solid #f1dd30",
        "@media (min-width: 992px)": {
            borderWidth: "0px"
        }
    }
});